import { Routes } from '@angular/router';

import { AuthGuard } from 'src/app/core/guard/auth.guard';

export const content: Routes = [
  {
    path: '',
    loadChildren: () => import('../../components/themes/themes.routes'),
    // ← no redirect, themes loads directly at ''
  },
  {
    path: 'auth',
    loadChildren: () => import('../../components/auth/auth.routes'),
  },
  {
    path: 'account',
    loadChildren: () => import('../../components/account/account.routes'),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () => import('../../components/shop/shop.routes'),
  },
  {
    path: '', // blog.routes defines 'blogs' and 'blog/:slug' itself
    loadChildren: () => import('../../components/blog/blog.routes'),
  },
  {
    path: '',
    loadChildren: () => import('../../components/page/page.routes'),
  },
  {
    path: '**',
    pathMatch: 'full',
    loadComponent: () => import('../../components/page/error404/error404').then(m => m.Error404),
    data: { privatePage: 'Page Not Found' }, // title + noindex (see App)
  },
];
